export const UNARCHIVE_DOCUMENT = 'unarchive/UNARCHIVE_DOCUMENT';
export const UNARCHIVE_DOCUMENT_ERROR = 'unarchive/UNARCHIVE_DOCUMENT_ERROR';
export const UNARCHIVE_DOCUMENT_SUCCESS = 'unarchive/UNARCHIVE_DOCUMENT_SUCCESS';
export const UNARCHIVE_RESET = 'unarchive/UNARCHIVE_RESET';
